module.exports = __webpack_public_path__ + "static/chickenavocado-9735e0f132b666d03a07660e37bffc7e.jpg";